/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { sendEvent } from "./interface";

export const trackOrganizeRotationTriggered = pageCount => {
  sendEvent("Organize", "Inline Organize", "Operation Info", {
    "adb.event.context.pdfViewer.opType": "rotate",
    "adb.event.context.pdfViewer.pageCount": pageCount
  });
};

export const trackOrganizeInsertTriggered = () => {
  sendEvent("Organize", "Inline Organize", "Operation Info", {
    "adb.event.context.pdfViewer.opType": "insert"
  });
};

export const trackDeleteOperationTriggered = pageCount => {
  sendEvent("Organize", "Inline Organize", "Operation Info", {
    "adb.event.context.pdfViewer.opType": "delete",
    "adb.event.context.pdfViewer.pageCount": pageCount
  });
};

export const trackReorderOperationTriggered = pageCount => {
  sendEvent("Organize", "Inline Organize", "Operation Info", {
    "adb.event.context.pdfViewer.opType": "reorder",
    "adb.event.context.pdfViewer.pageCount": pageCount
  });
};
